import { Box, Stack, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import muzukurulogo from "../../../assets/muzukurublack.png";
import ChurchBookingForm from "./components/ChurchBookingForm";
import FreeStreamsHero from "./components/FreeStreamsHero";

//const muzukurulogo = "/images/muzukurublack.png";

export default function FreeChurchStreamsPage() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        bgcolor: colors.primary[900],
        overflow: "hidden",
        minWidth: "1280px",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "95px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          backdropFilter: "blur(8px)",
          zIndex: 1200,
        }}
      >
        <Box
          component="img"
          src={muzukurulogo}
          alt="Muzukuru logo"
          sx={{
            width: 240,
            height: "auto",
          }}
        />
      </Box>

      {/* Hero Decorative Image */}
      {/* <HeroDecorativeImage decorative1={decorative1} /> */}

      {/* Hero Section */}
      <FreeStreamsHero
        title="Free Church Live Streaming."
        subtitle="Connect with your congregation anywhere in the world for free"
      />

      <Stack sx={{ alignItems: "center", mb: "80px" }}>
        <ChurchBookingForm />
      </Stack>

      {/* Scroll Arrows
      <Box
        sx={{
          position: "absolute",
          bottom: 24,
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        <ScrollArrows />
      </Box> */}

      {/* Services and About Section Container */}
      <Box sx={{ position: "relative" }}>
        {/* Decorative Images */}
        {/* <ServicesDecorativeImages decorative2={decorative2} /> */}

        {/* About Section */}
        {/* <AboutSection /> */}

        {/* Testimonials Section */}
        {/* <TestimonialsSection testimonials={testimonials} /> */}
      </Box>

      {/* Contact Section */}
      {/* <ContactSection
        branches={contactBranches}
        socialMediaIcons={socialMediaIcons}
      /> */}
    </Box>
  );
}
